import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-member-level",
  "use": "icon-member-level-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-member-level\"><defs><style type=\"text/css\"></style></defs><path d=\"M923.3 367l-125-208.3c-7.3-12-20.5-20-35.6-20H263.2c-15.1 0-28.3 8-35.7 20.2L102.7 367c-9 15.1-7.7 34.2 3.5 47.8l374.6 457.9 0.1 0.1C488.5 882 500 888 513 888s24.5-5.9 32.2-15.2l374.6-457.9c11.2-13.7 12.6-32.8 3.5-47.9z m-166.9 22.2L539.8 653.3c-6.4 7.8-15.6 11.8-25 11.9-0.6 0.1-1.2 0-1.9 0-0.6 0-1.2 0.1-1.9 0-9.3-0.2-18.6-4.1-25-11.9L269.6 389.2c-11.6-14.1-9.5-34.9 4.6-46.5s34.9-9.5 46.5 4.6L513 581.9l192.3-234.5c11.6-14.1 32.4-16.2 46.5-4.6 14.1 11.5 16.2 32.3 4.6 46.4z\" fill=\"#bfcbd9\" p-id=\"7546\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/member-level.svg
// module id = wyTZ
// module chunks = 81